import React from "react";
import "./Button.css";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
function Button() {
  const navigate = useNavigate();

  return (
    <div className="button-group">
      <button className="btn-outline" onClick={() => navigate("/partenaire")}>
        DEVENEZ NOTRE PARTENAIRE
      </button>
      <button className="btn-filled" onClick={() => navigate("/contact")}>
        CONTACTEZ-NOUS
        <Icon icon="majesticons:chevron-right-circle" width="24" height="24" />
      </button>
    </div>
  );
}

export default Button;
